import { render, staticRenderFns } from "./terminos_condiciones.vue?vue&type=template&id=575f68ba&scoped=true&"
import script from "./terminos_condiciones.vue?vue&type=script&lang=js&"
export * from "./terminos_condiciones.vue?vue&type=script&lang=js&"
import style0 from "./terminos_condiciones.vue?vue&type=style&index=0&id=575f68ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575f68ba",
  null
  
)

export default component.exports